export default __webpack_public_path__ + "static/media/background-home.68fe3bb0.png";